<template>
  <div
    v-click-outside="hide"
    class="filter__order filter-doctype"
    :class="{
      'filter__order--active': typeSelectView.visible,
      'filter-doctype--20321B': newStyle20321B,
    }"
    @click="typeSelectView.toggleMenu()"
  >
    <div class="filter__active">Content Types</div>
    <span class="filter__arr iconfont iarrow-down"></span>
    <transition name="fade">
      <ul
        v-show="typeSelectView.visible"
        class="filter__list filter-doctype__list"
      >
        <li
          v-for="opt in typeSelectView.options"
          :key="opt.name"
          class="filter__item filter-doctype__item"
          @click.prevent.stop="opt.click()"
        >
          <span>{{ opt.name }}</span>
          <span
            v-if="opt.isActive()"
            class="filter-doctype__check iconfont icheck-bold"
            aria-hidden="true"
          />
        </li>
      </ul>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { DocsView } from '@/models/doc'
import { DocsFilterTypeView } from '@/models/docs.filter'
import { assertNotNull } from '@/helpers/typing'

const props = defineProps<{
  view: DocsView
  newStyle20321B?: boolean
}>()

const typeSelectView = ref(new DocsFilterTypeView(props.view))

function hide(): void {
  assertNotNull(typeSelectView.value).hide()
}
</script>

<style lang="scss" scoped>
.filter-doctype {
  z-index: 4;
}
.filter-doctype--20321B {
  width: 200px;
  border-radius: 20px;
  .filter-doctype__item {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    &:not(:last-child) {
      padding-bottom: 8px;
    }

    &:not(:last-child):after {
      content: '';
      position: absolute;
      right: 8px;
      bottom: 0;
      left: 8px;
      height: 1px;
      background: $c-black-17;

      .night-mode & {
        background: $c-dark-5;
      }
    }
  }
}
</style>
